import axios from "axios";
import Select from "react-select";
import config from "../../../config/config";

import React, { useEffect, useState, useRef, useContext } from "react";
import DataTable from "react-data-table-component";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { uploadAWS } from "../../../common/AWSHelper";
import Loader from "../../../components/Loader/Loader";
import { AWS_IMAGE_FOLDER_RECEIVING } from "../../../common/Constant";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_CUSTOMER,
  AWS_IMAGE_FOLDER_WORKORDERS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import moment from "moment";
import ClearDataPayBill from "../../../components/Modal/ClearDataPayBill";
import { Modal } from "bootstrap";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import RecentTransactionsModal from "../../../components/Modal/RecentTransactionsModal";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";

const PayBills = () => {
  const { isManageSale, isManagePOSSale, AllowQBSync } = useContext(AppContext);
  let navigate = useNavigate();
  const paramObject = useParams();
  const buttonRef = useRef(null);
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  const [loading, setLoading] = useState(false);
  // const [todayDate, setTodayDate] = useState(moment().format("MM-DD-YYYY"));
  const [todayDate, setTodayDate] = useState(moment().format("YYYY-MM-DD"));
  const [amountReceived, setAmountReceived] = useState(0);
  const [FileUrl, setFileUrl] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(100);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [supplier, setSupplier] = useState([]);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [payeequickbookid, setpayeequickbookid] = useState(0);
  const [supplierOpenBalance, setSupplierOpenBalance] = useState(0);
  console.log(supplierOpenBalance,"supplierOpenBalance");
  
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [accountId, setAccountId] = useState("");
  const [sortingId, setSortingId] = useState(6);
  const [refrenceno, setRefrenceNo] = useState(0);
  const [selectedSupplier, setSelectedSupplier] = useState(0);
  const [oldSelectedSupplier, setOldSelectedSupplier] = useState(0);
  const [showPopupForWarning, setShowPopupForWarning] = useState(false);
  const [selectedRows, setSelectedRows] = useState("");
  const [value, setValue] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [formValues, setFormValues] = useState([]);
  let lengthOfFormValue = new Array(formValues?.length).fill(false);
  const [creditValidation, setCreditValidation] = useState([]);
  const [paymentValidation, setPaymentValidation] = useState([]);
  const [Accountquickbookid, setAccountquickbookid] = useState(0);

  const [firstLoad, setFirstLoad] = useState(true);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [showBillRedirectModal, setShowBillRedirectModal] = useState(false);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [redirectReceivingID, setRedirectReceivingID] = useState(false);
  const [answer1, setAnswer1] = useState(false);
  const [selectSupplierPassingEvent, setSelectSupplierPassingEvent] =
    useState();
  const [totalChecked, setTotalChecked] = useState(0);
  const [totalOpenBalance, setTotalOpenBalance] = useState(0);
  const [totalCreditValue, setTotalCreditValue] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [totalFinalAmount, setTotalFinalAmount] = useState(0);

  const [startOldDate, setStartOldDate] = useState("");
  const [endOldDate, setEndOldDate] = useState("");
  const [OldCustomDate, setOldCustomDate] = useState(0);

  const [beginningDate, setBeginningDate] = useState(
    moment().startOf("month").format("MM-DD-YYYY")
  );
  const [finalDate, setFinalDate] = useState(
    moment().endOf("month").format("MM-DD-YYYY")
  );
  const [customeDate, setCustomDate] = useState(3);
  const [payBillData, setPayBillData] = useState([]);

  const [creditValidationMessage, setCreditValidationMessage] = useState("");
  const [notlisteddata, setNotListedData] = useState([]);
  const [receivingpaymentid, setReceivingPaymentId] = useState(0);
  const [paymenttype, setPaymentType] = useState("");
  // const [latestCheckNumber, setLatestCheckNumber] = useState("");
  const [paymenttypeid, setPaymentTypeId] = useState(0);

  console.log(
    paymenttype,
    accountId,
    paymenttypeid,
    paymentMethod,
    "checkingfordata121"
  );

  const dateOptions = [
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
    { label: "Select", value: 0 },
  ];

  console.log(oldSelectedSupplier, "oldSelectedSuppliercheck");
  //Date

  console.log(formValues, "formValues");
  //Today
  let today = moment().format("MM-DD-YYYY");
  //Week
  const startOfWeek = moment().startOf("week").format("MM-DD-YYYY");
  const endOfWeek = moment().endOf("week").format("MM-DD-YYYY");
  //This Month
  const startOfMonth = moment().startOf("month").format("MM-DD-YYYY");
  const endOfMonth = moment().endOf("month").format("MM-DD-YYYY");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("MM-DD-YYYY");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("MM-DD-YYYY");
  //This Year
  const startOfYear = moment().startOf("year").format("MM-DD-YYYY");
  const endOfYear = moment().endOf("year").format("MM-DD-YYYY");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("MM-DD-YYYY");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("MM-DD-YYYY");

  const handleDateFilter = (event) => {
    setShowDateFilterModal(true);
    setOldCustomDate(customeDate);
    console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    }
  };

  //Date
  const handleDate = (event) => {
    setStartOldDate(beginningDate);
    // console.log(beginningDate, "From:")
    // console.log(event[0], "eventisss92");
    setBeginningDate(event);
    setCustomDate(7);
    setShowDateFilterModal(true);
  };

  const handleEndDate = (event) => {
    setEndOldDate(finalDate);
    setFinalDate(event);
    setCustomDate(7);
    setShowDateFilterModal(true);
  };

   const [QBpermission, setqbpermission] = useState(true);
  
    const handlepermission = () => {
      axios
        .get(`${config.salesconfigBaseUrl}/receivings/BillPaymentPermission`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          console.log(res.data.ResponseData[0].AppConfigvalue, "123");
          if (res.data.ResponseData[0].AppConfigvalue == "false") {
            setqbpermission(false);
          } else {
            setqbpermission(true);
          }
        })
        .catch((err) => {});
    };
  
    useEffect(() => {
      handlepermission();
    }, []);

  const handlepaymentdatechange = (event) => {
    setTodayDate(event);
  };

  console.log(startOldDate, endOldDate, "old date check");

  useEffect(() => {
    setCreditValidation(creditValidation);
    setTotalChecked(formValues.filter((item) => item.Checked == true).length);
    setTotalOpenBalance(
      formValues
        .filter((item) => item.Checked == true)
        .reduce((acc, cur) => {
          acc += +(cur.OPENBALANCE == undefined ? 0 : cur.OPENBALANCE);
          return acc;
        }, 0)
    );
    setTotalPayment(
      formValues
        .filter((item) => item.Checked == true)
        .reduce((acc, cur) => {
          acc += +(cur.PAYMENT == undefined ? 0 : cur.PAYMENT);
          return acc;
        }, 0)
    );
    setTotalCreditValue(
      formValues
        .filter((item) => item.Checked == true)
        .reduce((acc, cur) => {
          acc += +(cur.CREDITAPPLIEDVALUE == undefined
            ? 0
            : cur.CREDITAPPLIEDVALUE);
          return acc;
        }, 0)
    );
  }, [formValues]);

  const totalOpenbalance = () => {
    let data = formValues?.reduce((acc, next) => {
      acc += next.OPENBALANCE;
      return acc;
    }, 0);
    return data;
  };

  // const footer = {
  //   OPENBALANCE: totalOpenbalance(),
  //   // CREDITAPPLIEDVALUE: "Demo 3",
  //   // PAYMENT: "Demo 2",
  //   // "TOTAL AMOUNT": "Demo 1"
  // };

  const customFooter = (data) => {
    const total = data?.reduce((sum, item) => sum + item.OPENBALANCE, 0);
    return <div>Total: {total}</div>;
  };

  console.log(creditValidation, "creditValidation");
  //For persisting the data
  // const history = createBrowserHistory();

  // const [creditAppliedValue, setCreditAppliedValue] = useState(0);
  const [creditAppliedValue, setCreditAppliedValue] = useState([
    {
      receivingid: 0,
      supplierid: 0,
      value: 0,
    },
  ]);
  const [creditAppliedInputBox, setCreditAppliedInputBox] = useState(0);
  const [paymentInputBox, setPaymentInputBox] = useState(0);
  const [totalAmount, setTotalAmount] = useState();
  console.log("data 758", data);
  const [supplierCreditAppliedValue, setSupplierCreditAppliedValue] = useState(
    []
  );
  const [referenceNo, setReferenceNo] = useState("");
  const [printLater, setPrintLater] = useState(false);
  console.log(referenceNo, printLater,"referenceNoreferenceNo");
  const [rowCreditTotalAmount, setRowCreditTotalAmount] = useState([]);
  const [rowPaymentTotalAmount, setRowPaymentTotalAmount] = useState([]);
  // const [formValues, setFormValues] = useState({
  //   Customer: "",
  //   DepositTo: "",
  //   ReferenceNumber: "",
  //   PaymentMethod: "",
  //   InvoiceNumber: "",
  //   Memo: "",
  // });

  const handlePageChange = (page) => {
    const answer = window.confirm(
      "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    );
    if (answer) {
      setCurrentPage(page);
      handleListData(
        page,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        beginningDate,
        finalDate
      );
    }
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    const answer = window.confirm(
      "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    );

    if (answer) {
      setperPageSize(newPerPage);
      setCurrentPage(page);
      handleListData(
        page,
        newPerPage,
        searchtext,
        sortingId,
        sortingDirection,
        beginningDate,
        finalDate
      );
    }
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    // handleListData(
    //   1,
    //   perPageSize,
    //   searchtext,
    //   e.id,
    //   sortingDirection,
    //   beginningDate,
    //   finalDate
    // );
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      beginningDate,
      finalDate
    );
  };

  //Checkbox
  const handleCheckboxChange = (event, index) => {
    console.log("eventtttt", event);
    // console.log("event.target?.allSelected",event.target?.allSelected);
    setSelectedRows(event.selectedRows);
  };
  console.log("SelectedRows", selectedRows);
  console.log("supplierCreditAppliedValue336", supplierCreditAppliedValue);

  //Filter Supplier Id Credit

  // const filterCreditSupplierID = data.filter((el) => {
  //   // el.ReceivingID === rowPaymentTotalAmount.receivingID;
  //   console.log(el.ReceivingID, "data babujij");
  //   console.log(rowCreditTotalAmount.receivingID, "aaaaaaaaaaaaaabb");
  // });
  // console.log("filterrrrrrrrr", filterCreditSupplierID);
  // const filterPaymentSupplierID = data.filter((el) => {
  //   return el.ReceivingID === rowPaymentTotalAmount.receivingID;
  // });

  const filterRowCreditTotalAmount = rowCreditTotalAmount.filter(
    (e) => e?.isChecked === true
  );
  //Total Payment

  // console.log(formValues,"formValues")

  const total = formValues?.reduce((acc, curr) => {
    acc =
      acc +
      // (Number(parseFloat(curr?.CREDITAPPLIEDVALUE) && curr?.Checked == true ? parseFloat(curr?.CREDITAPPLIEDVALUE) : 0)) +
      Number(
        parseFloat(curr?.PAYMENT) && curr?.Checked == true
          ? parseFloat(curr?.PAYMENT)
          : 0
      );
    return acc;
  }, 0);

  console.log(total, "total");

  //Total when there is a payBill id

  const paymentTotal = payBillData?.reduce((acc, curr) => {
    acc += Number(
      parseFloat(curr?.PaymentAmount) ? parseFloat(curr?.PaymentAmount) : 0
    );
    return acc;
  }, 0);

  console.log(paymentTotal, "paymentTotal");

  console.log(payBillData, "payBillData417");

  //Overall Total payment and credit

  const editTotal = payBillData?.reduce((acc, curr) => {
    acc += Number(curr.CreditApplied) + Number(curr.PaymentAmount);
    return acc;
  }, 0);

  console.log(editTotal, "editTotal389");
  //handleChangeInput
  const handleInputChange = (event, index, fieldName) => {
    console.log(event, index, fieldName, "382");
    if (fieldName == "CreditApplied") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setPayBillData(updatedData);
    } else if (fieldName == "PaymentAmount") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setPayBillData(updatedData);
    } else if (fieldName == "RefNo") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setPayBillData(updatedData);
    } else if (fieldName === "PaymentTypeId") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[index],
        [fieldName]: parseInt(event.target.value),
      };
      setPayBillData(updatedData);
    }
  };

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  const selectStylesForPaymentMethod = {
    // dropdown input css
    // control: (provided, state) => ({
    //   ...provided,
    //   width: "100%",
    //   height: "40px",
    //   position: "relative",
    //   border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
    //   boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    //   "&:hover": {
    //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
    //   },
    // }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    // option: (provided, state) => ({
    //   ...provided,
    //   backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
    //   "&:hover": {
    //     backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
    //   },
    // }),
  };
  let supplierTypeDropdownOption = [];
  const termpsupplierlist = supplier.filter((u, i) => {
    // if (u.ID != 0) {
    supplierTypeDropdownOption[i] = {
      // label:u.FirstName,
      label: u.CompanyName,
      // + " (" + (u.FirstName + " " + u.LastName) + ")"
      value: u.ID,
      quickbookid: u.QuickBookId,
      supplierbalance: u.Balance,
    };
    // }
  });

  console.log(supplierTypeDropdownOption, "supplierTypeDropdownOption");

  // selectedSupplier != 0 ? (

  //   supplier.filter((u, i) => {

  //     if( u.ID != 0){
  //       supplierTypeDropdownOption[i] = {
  //         label: u.FirstName,
  //         value: u.ID,
  //       }
  //       }
  //     })
  //     ) : (
  //   supplier.filter((u, i) => {

  //     if( u.ID != 0){
  //       supplierTypeDropdownOption[i] = {
  //         label: u.FirstName,
  //         value: u.ID,
  //       }
  //       }
  //     })
  // )

  console.log(supplierTypeDropdownOption, "supplierTypeDropdownOption");
  // Account Type Dropdown
  let accountTypeDropdownOption = [];

  const AccountDropdown = chartOfAccountDropdown.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
      quickbookid: u.QuickbookId,
      AccountType: u.AccountType,
      parentName: u.ParentName ? u.ParentName.trim() : ""
    };
  });

  //   Customer Drop Down
  let customerOption = [];
  const customerDropdown = customer.map((u, i) => {
    customerOption[i] = {
      label: u.FirstName + " " + u.LastName,
      value: u.Id,
    };
  });

  //   Payment Method Drop Down
  let paymentMethodOption = [];
  const payementDropdown = paymentMethod.map((u, i) => {
    paymentMethodOption[i] = {
      label: u.Paymenttypename,
      value: u.ID,
      PaymentQuickbookId: u.PaymentQuickbookId,
    };
  });

  let paymentMethodOptionForStoreAccount = [];
  const payementDropgdown1 = paymentMethod.filter((u, i) => {
    return u.ID != 6
      ? (paymentMethodOptionForStoreAccount[i] = {
          label: u.Paymenttypename,
          value: u.ID,
        })
      : "";
  });

  console.log(paymentMethodOption, "<=====paymentMethod");
  // console.log(paymentMethodOptionForStoreAccount, "paymentMethod");

  // const handleChangeCheckbox = (e, row) => {
  //   // setValue(e.target.checked);
  //   console.log("eiiiiiiii 445566", e.target.checked, row);

  //   console.log("row.ReceivingID ==> 445566 ", row.ReceivingID);

  //   // Filter data in CreditApplied Amount
  //   // let creditAppliedAmountObject = rowCreditTotalAmount.filter(
  //   //   (e) => e?.receivingID === row.ReceivingID
  //   // );

  //   //find Index in Credit
  //   const creditAppliedAmountObjectIndex = rowCreditTotalAmount.findIndex(
  //     (e) => e?.receivingID === row.ReceivingID
  //   );

  //   console.log(
  //     "creditAppliedAmountObjectIndex",
  //     creditAppliedAmountObjectIndex
  //   );
  //   //Filter data in PaymentApplied Amount
  //   // let paymentAmountObject = rowPaymentTotalAmount.filter(
  //   //   (e) => e?.receivingID === row.ReceivingID
  //   // );

  //   //find Index in Payment
  //   const paymentAmountObjectIndex = rowPaymentTotalAmount.findIndex(
  //     (e) => e.receivingID == row.ReceivingID
  //   );
  //   console.log("paymentAmountObjectIndex", paymentAmountObjectIndex);

  //   console.log("rowPaymentTotalAmount 259 ==> ", rowPaymentTotalAmount);
  //   console.log("rowCreditTotalAmount 260 ==> ", rowCreditTotalAmount);

  //   if (creditAppliedAmountObjectIndex != -1) {
  //     // creditAppliedAmountObject.isChecked = e.target.checked;

  //     const creditAppliedAmountObject =
  //       rowCreditTotalAmount[creditAppliedAmountObjectIndex];
  //     creditAppliedAmountObject.isChecked = e.target.checked;

  //     const updatedcreditAppliedAmountObject = [...rowCreditTotalAmount];
  //     updatedcreditAppliedAmountObject[creditAppliedAmountObjectIndex] =
  //       creditAppliedAmountObject;
  //     setRowCreditTotalAmount(updatedcreditAppliedAmountObject);
  //   }

  //   if (paymentAmountObjectIndex != -1) {
  //     // paymentAmountObject.isChecked = e.target.checked;

  //     const paymentAmountObject =
  //       rowPaymentTotalAmount[paymentAmountObjectIndex];
  //     paymentAmountObject.isChecked = e.target.checked;

  //     const updatedpaymentAmountObject = [...rowPaymentTotalAmount];
  //     updatedpaymentAmountObject[paymentAmountObjectIndex] =
  //       paymentAmountObject;
  //     setRowPaymentTotalAmount(updatedpaymentAmountObject);
  //   }

  //   // console.log("rowCreditTotalAmount 288==>", rowCreditTotalAmount);
  //   // console.log("rowPaymentTotalAmount 289==>", rowPaymentTotalAmount);
  //   // let creditAppliedAmount = creditAppliedAmountObject
  //   //   ? creditAppliedAmountObject?.creditApplied
  //   //   : 0;

  //   // let paymentAmount = paymentAmountObject ? paymentAmountObject?.payment : 0;

  //   // let rowWiseTotalAmount =
  //   //   parseFloat(creditAppliedAmount) + parseFloat(paymentAmount);
  // };

  //h
  // Outstanding Table Column

  // const handleChangeCheckbox = (e,index) => {
  //   setFormValues((formData) => {
  //     return formData.map((item, i) => {
  //       if (i === index) {
  //         return { ...item, Checked: !item.Checked };
  //       } else {
  //         return item;
  //       }
  //     });
  //   });
  // };
  let outstandingColumns;

  console.log("supplier 595", supplier);
  if (paramObject.id > 0) {
    outstandingColumns = [
      // {
      //   name: "Sr.No.",
      //   selector: (row, index) => index + 1,
      //   sortable: true,
      //   width: "100px",
      // },
      {
        name: "PAYEE",
        selector: (row) => {
          const payee = supplier.find((el) => el && el.ID === row?.PayeeID);
          console.log("row, payee", row, payee);
          return payee ? payee.FirstName : "";
        },
        // width: "150px",
        sortable: true,
        wrap: true,
      },
      {
        name: "BILL NUMBER",
        selector: (row) => row["BillNo"],
        sortable: true,
        wrap: true,
        // width: "100px",
      },
      {
        name: "DUE DATE",
        selector: (row) =>
          moment(row["DueDate"]).format(`${dateFormate.toUpperCase()}`),
        sortable: true,
        wrap: true,
        // width: "100px",
      },
            {
        name: "ORIGINAL AMOUNT",
        cell: (row) => {
          return (
            <div>
              <div>
                <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: row["SyncStatus"] == 1 ? "green" : "red",
                  marginRight: "8px",
                }}
                ></span>
                {CurrencySymbols(
                  row["Total"],
                  CurrencySymbol,
                  FractionDigits
                )}
              </div>
            </div>
          );
        },
        sortable: true,
        wrap: true,
      },
      {
        name: "OPEN BALANCE",
        // selector: (row) => parseFloat(row["OPENBALANCE"]).toFixed(2),
        cell: (row) => {
          return (
            <div>
              <div>
                {CurrencySymbols(
                  parseFloat(row["OPENBALANCE"]).toFixed(2),
                  CurrencySymbol,
                  FractionDigits
                )}
              </div>
              <div>{row.BILLTYPE}</div>
            </div>
          );
        },

        sortable: true,
        wrap: true,
        // width: "100px",
      },
      // not working
      // {
      //   name: "CREDIT APPLIED",
      //   selector: (row) => row["CREDITAPPLIED"],
      //   // selector: (row) =>
      //   //   row?.CreditApplied ? parseFloat(row?.CreditApplied).toFixed(2) : 0.0,
      //   sortable: true,
      //   width: "180px",
      //   right: true,
      //   cell: (row, index) => {
      //     return (
      //       <div>
      //         <input
      //           className="form-control form-control-sm mt-1 mb-1"
      //           type="number"
      //           name="CREDITAPPLIEDVALUE"
      //           id="CREDITAPPLIEDVALUE"
      //           // min={0}
      //           value={
      //             // payBillData?.find((el) => el?.ReceivingId == row?.ReceivingId)
      //             //   ?.CreditApplied
      //             Math.abs(payBillData[0]?.CreditApplied)
      //           }
      //           onChange={(event) => {
      //             handleInputChange(event, index, "CreditApplied")
      //             handleCellChange(event, row, index);
      //           }}
      //         />

      //         {creditValidation[index] && (
      //           <p className="text-danger mb-0">
      //             Value must not exceed{" "}
      //             {parseInt(payBillData[0]?.OPENBALANCE)}
      //           </p>
      //         )}
      //         {
      //           // (paramObject.id > 0) ?
      //           (
      //             <div>
      //               {supplierCreditAppliedValue.find(
      //                 (item) => item.supplierid === row.SupplierId
      //               )
      //                 ? supplierCreditAppliedValue.find(
      //                   (item) => item.supplierid === row.SupplierId
      //                 )?.CustomerBalance :
      //                 parseFloat(payBillData[0]?.CustomerBalance).toFixed(2) + " Available"}
      //             </div>
      //           )
      //           // : (
      //           //   <div style={{ color: "#6b6c72" }}>
      //           //     {supplierCreditAppliedValue.find(
      //           //       (item) => item.supplierid === row.SupplierID
      //           //     )
      //           //       ? supplierCreditAppliedValue.find(
      //           //         (item) => item.supplierid === row.SupplierID
      //           //       )?.availableAmount
      //           //       : parseFloat(row.CREDITAPPLIED).toFixed(2)}{" "}
      //           //     Available
      //           //   </div>
      //           // )
      //         }

      //       </div>
      //     )
      //   }
      // },
      {
        name: "CREDIT APPLIED",
        selector: (row) => row["CREDITAPPLIED"],
        //  width: "200px",
        sortable: true,
        wrap: true,
        cell: (row, index) => {
          if (row?.CREDITAPPLIED > 0) {
            return (
              <div>
                {/* {console.log("row.id", row.ReceivingID)} */}

                <input
                  className="form-control form-control-sm mt-3 mb-1"
                  type="number"
                  name="CREDITAPPLIEDVALUE"
                  id="CREDITAPPLIEDVALUE"
                  // min={0}
                  value={
                    formValues.find((el) => el?.ReceivingID == row?.ReceivingID)
                      ?.CREDITAPPLIEDVALUE
                  }
                  // onChange={(event) => handleCellChange(event, index)}
                  // onChange={(event) => handleCellChange(event, row, index)}
                  onChange={(event) => {
                    handleChangeInput(event, index, "CREDITAPPLIEDVALUE", row);
                    handleCellChange(event, row, index);
                  }}
                />

                <div style={{ color: "#6b6c72" }}>
                  {CurrencySymbols(
                    supplierCreditAppliedValue.find(
                      (item) => item.supplierid === row?.SupplierID
                    )
                      ? supplierCreditAppliedValue.find(
                          (item) => item.supplierid === row?.SupplierID
                        )?.availableAmount
                      : parseFloat(row?.CREDITAPPLIED).toFixed(2),
                    CurrencySymbol,
                    FractionDigits
                  )}
                  Available
                  {/* {supplierCreditAppliedValue.find(
                   (item) => item.supplierid === row.SupplierID
                 )?.availableAmount > 0
                   ? supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   : parseFloat(row.CREDITAPPLIED).toFixed(2)
                   }{" "} */}
                  {/* Available */}
                  <>
                    {/* {
                     supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   } */}
                  </>
                  {/* <br></br>
                 {isNaN(creditAppliedValue.availableAmount)
                   ? row.CREDITAPPLIED
                   : creditAppliedValue.availableAmount}{" "}
                 Available */}
                </div>
              </div>
            );
          } else {
            return <div style={{ color: "#6b6c72" }}>Not Available</div>;
          }
        },
      },

      // {
      //   name: "PAYMENT",
      //   // selector: (row) => parseFloat(row["PaymentAmount"]).toFixed(2),
      //   sortable: true,
      //   width: "180px",
      //   right: true,
      //   cell: (row, index) => (
      //     <div>
      //       <input
      //         className="form-control form-control-sm mb-1"
      //         type="number"
      //         name="PAYMENT"
      //         id="PAYMENT"
      //         // value={payBillData?.find((el) => el?.ReceivingId == row?.ReceivingId)
      //         //   ?.PaymentAmount}
      //         value={Number(payBillData[0]?.PaymentAmount)}
      //         onChange={(event) => {
      //           handleInputChange(event, index, "PaymentAmount")
      //         }}
      //       />
      //     </div>
      //   ),
      // },
      {
        name: "PAYMENT",
        // width: "150px",
        sortable: true,
        wrap: true,
        cell: (row, index) => (
          <input
            className="form-control form-control-sm mt-1 mb-1"
            type="number"
            name="PAYMENT"
            id="PAYMENT"
            onFocus={(event) => event.target.select()}
            value={formValues[index]?.PAYMENT}
            onChange={(event) => {
              handleChangeInput(event, index, "PAYMENT", row);
            }}
            // onChange={(event) => handleChangePayment(event, index)}
          />
        ),
      },
      // {
      //   name: "PAYMENT METHOD",
      //   width: "200px",
      //   cell: (row, index) => (
      //     <>
      //       <select
      //         id="PaymentMethod"
      //         name="PaymentMethod"
      //         className="form-select form-select-sm"
      //         onChange={(event) =>
      //           handleInputChange(event, index, "PaymentTypeId")
      //         }
      //       >
      //         {paymentMethodOptionForStoreAccount?.map((e) => {
      //           return (
      //             <option value={e?.value == row.PaymentTypeId}>
      //               {e?.label}
      //             </option>
      //           );
      //         })}
      //       </select>
      //     </>
      //   ),
      //   sortable: true,
      // },
      // {
      //   name: "Reference Number",
      //   // selector: (row) => row["RefNo"],
      //   sortable: true,
      //   width: "200px",
      //   cell: (row, index) => (
      //     <input
      //       className="form-control form-control-sm mt-1 mb-1"
      //       type="text"
      //       name="RefrenceNumber"
      //       id="RefrenceNumber"
      //       onChange={(event) => {
      //         handleInputChange(event, index, "RefNo");
      //       }}
      //     />
      //   ),
      // },
      // {
      //   name: "TOTAL AMOUNT",
      //   // selector: (row) => Number(row["Total"]).toFixed(2),
      //   sortable: true,
      //   width: "180px",
      //   right: true,
      //   cell: () => {
      //     return (
      //       <div>{editTotal ? editTotal : 0}</div>
      //     )
      //   }
      // },
      // {
      //   name: "PAYMENT METHOD",
      //   // selector: "ID",
      //   // width: "200px",
      //   wrap: true,
      //   cell: (row, index) => (
      //     <>
      //       <select
      //         id="PaymentMethod"
      //         name="PaymentMethod"
      //         className="form-select form-select-sm"
      //         onChange={(event) =>
      //           handleChangeInput(event, index, "PaymentMethod", row)
      //         }
      //         value={formValues[index]?.PaymentMethod}
      //       >
      //         {formValues[index]?.PAYMENT > 0
      //           ? paymentMethodOptionForStoreAccount?.map((e) => {
      //               return <option value={e?.value}>{e?.label}</option>;
      //             })
      //           : paymentMethodOption?.map((e) => {
      //               return <option value={e?.value}>{e?.label}</option>;
      //             })}
      //       </select>

      //       {/* <Select
      //        options={paymentMethodOption}
      //        placeholder="Payment Method"
      //        backspaceRemovesValue={false}
      //        controlShouldRenderValue={true}
      //        hideSelectedOptions={true}
      //        isClearable={true}
      //        // // style={{
      //        // //   position: "absolute",
      //        // //   "z-index": "999",
      //        // //   background: "#f8f8f8",
      //        // //   width: "100%",
      //        // // }}
      //        // id="PaymentMethod"
      //        name="PaymentMethod"
      //        onChange={(event) =>
      //          handleChangeInput(event, index, "PaymentMethod", row)
      //        }
      //      // onChange={(e) => handleChangePayment(e, index, "PaymentMethod", row)}
      //      /> */}
      //     </>
      //   ),
      //   sortable: true,
      //   wrap: true,
      // },
      // {
      //   name: "Refrence Number",
      //   // width: "200px",
      //   wrap: true,
      //   sortable: true,
      //   cell: (row, index) => (
      //     <input
      //       className="form-control form-control-sm mt-1 mb-1"
      //       type="text"
      //       name="RefrenceNumber"
      //       id="RefrenceNumber"
      //       onChange={(event) => {
      //         handleChangeInput(event, index, "RefrenceNumber", row);
      //       }}
      //       value={formValues[index]?.RefrenceNumber}
      //     />
      //   ),
      // },
      {
        name: "TOTAL AMOUNT",
        wrap: true,
        // width: "100px",
        sortable: true,
        selector: "TOTAL AMOUNT",
        cell: (row, index) => (
          <>
            {/* {console.log("aaaaaaaaaaaaaaaaaaaaaa", rowPaymentTotalAmount)} */}
            {/* <div>{rowTotalAmount[index]?.totalAmount || 0}</div>
           <div>{console.log("aaaaaaaaaaa=...", rowTotalAmount)}</div> */}
            <div>
              {/* {parseFloat(row.PAYMENT ? row.PAYMENT : 0) +
               parseFloat(row.CREDITAPPLIEDVALUE ? row.CREDITAPPLIEDVALUE : 0)} */}
              {/* {(parseFloat(rowPaymentTotalAmount[index]?.payment)
               ? parseFloat(rowPaymentTotalAmount[index]?.payment)
               : 0) +
               (parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 ? parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 : 0)} */}
              {(parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                ? parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                : 0) +
                (parseFloat(formValues[index]?.PAYMENT)
                  ? parseFloat(formValues[index]?.PAYMENT)
                  : 0)}
            </div>

            {/* <span>{rowTotalAmount.map((e, i) => e.totalAmount[i])}</span> */}
          </>
        ),
      },
    ];
  } else {
    outstandingColumns = [
      {
        name: "",
        // selector: (row, index) => ,
        sortable: false,
        width: "40px",
        wrap: true,
        cell: (row, index) => {
          return (
            <>
              <input
                type="checkbox"
                name="Checked"
                checked={formValues[index]?.Checked}
                onChange={(event) =>
                  handleChangeInput(event, index, "Checked", row)
                }
              />
            </>
          );
        },
      },
      // {
      //   name: "Sr.No.",
      //   selector: (row, index) => index + 1,
      //   sortable: true,
      //   width: "100px",
      // },
      {
        name: "PAYEE",
        // selector: (row) => row["PAYEE"],
        selector: (row) => (
          <p className="word-break-data" title={row.PAYEE}>
            {row.PAYEE}
          </p>
        ),
        sortable: true,
        wrap: true,
        // width: "150px",
      },
      {
        name: "BILL NUMBER",
        // selector: (row) => row["REFNO"],
        sortable: true,
        // width: "140px",
        wrap: true,
        cell: (row, index) => {
          return (
            <div>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => NavigateToRecBill(row.ReceivingID)}
              >
                {row.REFNO == 0 ? "" : row.REFNO}
              </p>
            </div>
          );
        },
      },
      {
        name: "DUE DATE",
        selector: (row) =>
          row["DUEDATE"] != null ? (
            <>
              {moment(row["DUEDATE"]).isBefore(moment()) ? (
                <>
                  <i class="fa fa-circle" style={{ color: "red" }}></i> {" "}
                  {moment(row["DUEDATE"]).format(
                    `${dateFormate.toUpperCase()}`
                  )}
                </>
              ) : (
                moment(row["DUEDATE"]).format(`${dateFormate.toUpperCase()}`)
              )}
            </>
          ) : (
            ""
          ),
        sortable: true,
        wrap: true,
        // width: "140px",
      },
      {
        name: "ORIGINAL AMOUNT",
        selector: (row) => Number(row["Total"] || 0).toFixed(2),
        cell: (row) => {
          return (
            <div>
              <div>
                <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: row["SyncStatus"] == 1 ? "green" : "red",
                  marginRight: "8px",
                }}
                ></span>
                {CurrencySymbols(
                  row["Total"],
                  CurrencySymbol,
                  FractionDigits
                )}
              </div>
            </div>
          );
        },
        sortable: true,
        wrap: true
      },
      {
        name: "OPEN BALANCE",
        selector: (row) => parseFloat(row["OPENBALANCE"]).toFixed(2),
        cell: (row) => {
          return (
            <div>
              <div>
                {CurrencySymbols(
                  parseFloat(row["OPENBALANCE"]).toFixed(2),
                  CurrencySymbol,
                  FractionDigits
                )}
              </div>
              <div>{row.BILLTYPE}</div>
            </div>
          );
        },

        // width: "180px",
        sortable: true,
        wrap: true,
        footer: customFooter(),
      },
      {
        name: "CREDIT APPLIED",
        selector: (row) => row["CREDITAPPLIED"],
        // width: "200px",
        sortable: false,
        wrap: true,
        cell: (row, index) => {
          if (row.CREDITAPPLIED > 0) {
            return (
              <div>
                {/* {console.log("row.id", row.ReceivingID)} */}

                <input
                  className="form-control form-control-sm mt-1 mb-1"
                  type="number"
                  name="CREDITAPPLIEDVALUE"
                  id="CREDITAPPLIEDVALUE"
                  min={0}
                  value={
                    formValues.find((el) => el?.ReceivingID == row?.ReceivingID)
                      ?.CREDITAPPLIEDVALUE
                  }
                  // onChange={(event) => handleCellChange(event, index)}
                  // onChange={(event) => handleCellChange(event, row, index)}
                  onChange={(event) => {
                    handleChangeInput(event, index, "CREDITAPPLIEDVALUE", row);
                    handleCellChange(event, row, index);
                  }}
                />

                <div style={{ color: "#6b6c72" }}>
                  {CurrencySymbols(
                    Number(
                      supplierCreditAppliedValue.find(
                        (item) => item.supplierid === row.SupplierID
                      )
                        ? supplierCreditAppliedValue.find(
                            (item) => item.supplierid === row.SupplierID
                          )?.availableAmount
                        : parseFloat(row.CREDITAPPLIED).toFixed(2)
                    ),
                    CurrencySymbol,
                    FractionDigits
                  )}
                  Available
                  {/* {supplierCreditAppliedValue.find(
                   (item) => item.supplierid === row.SupplierID
                    )?.availableAmount > 0
                    ? supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   : parseFloat(row.CREDITAPPLIED).toFixed(2)
                   }{" "} 
                   Available */}
                  {/* <> 
                   {
                     supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   } 
                  </>
                  <br></br> */}
                  {/* {isNaN(creditAppliedValue.availableAmount)
                   ? row.CREDITAPPLIED
                   : creditAppliedValue.availableAmount}{" "}
                 Available  */}
                </div>
              </div>
            );
          } else {
            return <div style={{ color: "#6b6c72" }}>Not Available</div>;
          }
        },
      },
      {
        name: "PAYMENT",
        // width: "150px",
        sortable: false,
        wrap: true,
        cell: (row, index) => (
          <div>
            <input
              className="form-control form-control-sm mt-1 mb-1"
              type="number"
              name="PAYMENT"
              id="PAYMENT"
              value={formValues[index]?.PAYMENT}
              onFocus={(event) => event.target.select()}
              onChange={(event) => {
                handleChangeInput(event, index, "PAYMENT", row);
              }}
              // onChange={(event) => handleChangePayment(event, index)}
            />
            {paymentValidation[index] && (
              <p className="text-danger mb-0">payment limit reached</p>
            )}
          </div>
        ),
      },
      // {
      //   name: "PAYMENT METHOD",
      //   // selector: "ID",
      //   // width: "200px",
      //   wrap: true,

      //   cell: (row, index) => (
      //     <>
      //       <select
      //         id="PaymentMethod"
      //         name="PaymentMethod"
      //         className="form-select custom-select-sm"
      //         styles={CUSTOM_SELECT_DROPDOWN_STYLE}
      //         onChange={(event) =>
      //           handleChangeInput(event, index, "PaymentMethod", row)
      //         }
      //       >
      //         {formValues[index]?.PAYMENT > 0
      //           ? paymentMethodOptionForStoreAccount?.map((e) => {
      //               return (
      //                 <option value={e?.value} key={e?.label}>
      //                   {e?.label}
      //                 </option>
      //               );
      //             })
      //           : paymentMethodOption?.map((e) => {
      //               return (
      //                 <option value={e?.value} key={e?.label}>
      //                   {e?.label}
      //                 </option>
      //               );
      //             })}
      //       </select>

      //       {/* <Select
      //        options={paymentMethodOption}
      //        placeholder="Payment Method"
      //        backspaceRemovesValue={false}
      //        controlShouldRenderValue={true}
      //        hideSelectedOptions={true}
      //        isClearable={true}
      //        // // style={{
      //        // //   position: "absolute",
      //        // //   "z-index": "999",
      //        // //   background: "#f8f8f8",
      //        // //   width: "100%",
      //        // // }}
      //        // id="PaymentMethod"
      //        name="PaymentMethod"
      //        onChange={(event) =>
      //          handleChangeInput(event, index, "PaymentMethod", row)
      //        }
      //      // onChange={(e) => handleChangePayment(e, index, "PaymentMethod", row)}
      //      /> */}
      //     </>
      //   ),
      //   sortable: true,
      // },
      // {
      //   name: "REFERENCE NUMBER",
      //   //width: "200px",
      //   sortable: true,
      //   wrap: true,
      //   cell: (row, index) => (
      //     <input
      //       className="form-control form-control-sm mt-1 mb-1"
      //       type="text"
      //       name="RefrenceNumber"
      //       id="RefrenceNumber"
      //       onChange={(event) => {
      //         handleChangeRef(event);
      //       }}
      //     />
      //   ),
      // },
      {
        name: "TOTAL AMOUNT",
        //width: "200px",
        sortable: false,
        wrap: true,
        selector: "TOTAL AMOUNT",
        cell: (row, index) => (
          <>
            {/* {console.log("aaaaaaaaaaaaaaaaaaaaaa", rowPaymentTotalAmount)} */}
            {/* <div>{rowTotalAmount[index]?.totalAmount || 0}</div>
           <div>{console.log("aaaaaaaaaaa=...", rowTotalAmount)}</div> */}
            <div>
              {/* {parseFloat(row.PAYMENT ? row.PAYMENT : 0) +
               parseFloat(row.CREDITAPPLIEDVALUE ? row.CREDITAPPLIEDVALUE : 0)} */}
              {/* {(parseFloat(rowPaymentTotalAmount[index]?.payment)
               ? parseFloat(rowPaymentTotalAmount[index]?.payment)
               : 0) +
               (parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 ? parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 : 0)} */}
              {CurrencySymbols(
                Number(
                  (parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                    ? parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                    : 0) +
                    (parseFloat(formValues[index]?.PAYMENT)
                      ? parseFloat(formValues[index]?.PAYMENT)
                      : 0)
                ),
                CurrencySymbol,
                FractionDigits
              )}
            </div>

            {/* <span>{rowTotalAmount.map((e, i) => e.totalAmount[i])}</span> */}
          </>
        ),
      },
    ];
  }

  // Validation for the file upload
  const vaidation = (name, value) => {
    switch (name) {
      case "Attachment":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf|heic)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  console.log(payBillData, "payBillData");
  const handleConfirmationSubmit = (afterSaveActionType) => {
    if (balanceAmount !== 0) {
      if (totalCreditValue + totalPayment <= 0 && paramObject.id == undefined) {
        toastError("Please fill the Payment");
        return;
      }
      if (balanceAmount - total < 0) {
        const modalElement = document.getElementById("FundModal");
        const modal = Modal.getOrCreateInstance(modalElement);
        modal.show();
      } else {
        handleSubmit(afterSaveActionType);
      }
    } else {
      toastError("Please select account first");
      window.scrollTo(0, 0);
      return;
    }
  };

  // Upload function for uploading the file on AWS
  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "Attachment") {
          setFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  // Handle the for the file change
  const handleFileChange = (event, index) => {
    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      // console.log(event.currentTarget.files[0]);
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  const SupplierAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        //console.log("response", response.data.ResponseData[0]);

        setSupplier([
          { FirstName: "Select Supplier", ID: 0 },
          ...response.data.ResponseData,
        ]);
        // setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const latestCheckNumberAPI = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/getlatestchecknumberbyaccount?accountid=${accountId}&paymenttypeid=${paymenttypeid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        console.log(res.data.ResponseData, "resDatacheking");
        let takeNumber = res.data.ResponseData[0]?.NextRefno;
        console.log(takeNumber, "takeNumber");

        setReferenceNo(takeNumber);
        // setLoading(false);
      });
  };

  console.log(supplier, "supplier1387");

  // Payment Method Drop Down Binding API CALL
  // const PaymentMethodAPI = () => {
  //   axios
  //     .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     })

  //     .then((res) => {
  //       setLoading(true);
  //       setPaymentMethod(res.data.ResponseData);
  //       setLoading(false);
  //     });
  // };

  const PaymentMethodAPI = () => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/transactionpaymentdropdown?module=pay_bill`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        // setLoading(true);
        let resData = res.data.ResponseData.filter(
          (u) =>
            u.Paymenttypename === "Credit Card" || u.Paymenttypename === "Check"
        );
        console.log(resData, "resData");

        setPaymentMethod(res.data.ResponseData);
        // setLoading(false);
      });
  };

  console.log(balanceAmount, "balanceAmount");
  // Customer Drop Down Binding API CALL
  const CustomerAPI = () => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(true);
        setCustomer(res.data.ResponseData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const AccountAPI = () => {
    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, { //type=3
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("ChartOfAccountDropdown", res.data.ResponseData);
        const filteredAccounts = res.data.ResponseData.filter(item => item.AccountType == "Credit Card" || item.AccountType == "Bank");

        console.log(filteredAccounts,"filteredAccounts");
        
        
        setChartOfAccountDropdown(filteredAccounts);
        // setLoading(false);
        // localStorage.setItem("441-", JSON.stringify(res.data.ResponseData));
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log("chartOfAccountDropdown 1076", chartOfAccountDropdown);

  // Handle the cancel to redirect it to sales list
  // const handleCancel = () => {
  //   navigate("/receiving");
  // };

  const handleCancelRedirect = () => {
    setShowBillRedirectModal(false);
    setRedirectReceivingID(0);
  };

  const handleConfirmRedirect = () => {
    setShowBillRedirectModal(false);
    // navigate(`/manage-receiving/${redirectReceivingID}`);
    navigate(
      isManageSale == 1
        ? `/manage-receiving/${redirectReceivingID}`
        : isManagePOSSale == 1
        ? `/pos-receiving/${redirectReceivingID}`
        : "#"
    );
  };

  // useEffect(()=>{

  //   if(beginningDate!==""){
  //     setShowDateFilterModal(true);
  //   }else if(finalDate !==""){
  //     setShowDateFilterModal(true);
  //   }

  //   if(startOldDate == beginningDate || finalDate == endOldDate){
  //     return
  //   }

  // }, [beginningDate, finalDate])

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setBeginningDate(startOldDate);
    setFinalDate(endOldDate);
    setCustomDate(OldCustomDate);
  };

  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      selectedSupplier,
      refrenceno,
      beginningDate,
      finalDate
    );
  };

  const NavigateToRecBill = (ReceivingID) => {
    console.log("clicked", ReceivingID);
    setShowBillRedirectModal(true);
    setRedirectReceivingID(ReceivingID);
  };

  const handleUpdateCreditApplied = (newValue, supplierID, receivingID) => {
    console.log(newValue, supplierID, receivingID, "handleUpdateCreditApplied");
    const existingItemIndex = creditAppliedValue.findIndex(
      (item) =>
        item.supplierid === supplierID && item.receivingid === receivingID
    );
    console.log("existingItemIndex ===>", existingItemIndex);
    if (existingItemIndex !== -1) {
      const existingItem = creditAppliedValue[existingItemIndex];
      existingItem.value = parseFloat(newValue);
      // existingItem.availableAmount = parseFloat(availableAmount);
      const updatedDataNew = [...creditAppliedValue];
      updatedDataNew[existingItemIndex] = existingItem;
      setCreditAppliedValue(updatedDataNew);
    } else {
      setCreditAppliedValue([
        ...creditAppliedValue,
        {
          receivingid: receivingID,
          supplierid: supplierID,
          value: newValue,
          // availableAmount: availableAmount
        },
      ]);
    }

    console.log("handleUpdateCreditApplied ==>", creditAppliedValue);
  };

  // const handleChangePayment = (e, index, fieldName) => {
  //   setSupId(data[index].SupplierID);

  //   var name = "";
  //   if (fieldName == "PaymentMethod") {
  //     name = fieldName;
  //   } else {
  //     name = e?.target?.name;
  //   }

  //   var value = 0;
  //   if (fieldName == "PaymentMethod") {
  //     value = e.value;
  //   } else {
  //     var name = e?.target?.name;
  //     value = e.target.value;
  //   }

  //   const updatedData = [...data];

  //   updatedData[index] = { ...updatedData[index], [name]: value };

  //   setData(updatedData);
  // };

  const handleYes = () => {
    console.log("call result answer");
    setAnswer1(true);
  };
  // const handleNo = () => {
  //   console.log("call result answer 1")
  //   // setAnswer1(false);
  // };

  useEffect(() => {
    console.log(answer1, "return from popup under function answer");
    if (!answer1) {
      console.log("selectedSupplier", selectedSupplier);
      console.log(answer1, "answer");
      // setOldSelectedSupplier(selectedSupplier)
      // setSelectedSupplier(2);
      // setShowPopupForWarning(false)
      setTimeout(() => {
        console.log("CALL 1 Second", oldSelectedSupplier);
        setSelectedSupplier(oldSelectedSupplier);
      }, 1000);

      return;
    } else {
      setSelectedSupplier(selectSupplierPassingEvent);
      setOldSelectedSupplier(selectSupplierPassingEvent);
      setAnswer1(false);
      setFormValues([]);
    }
  }, [answer1]);

  const selectSupplierHandle = async (event) => {
    buttonRef.current.click();
    console.log(event, "event value after click");
    // setShowPopupForWarning(true);

    // if (selectedSupplier == undefined) {
    //   setTimeout(() => {
    //     setSelectedSupplier(0);
    //     setOldSelectedSupplier(0);
    //   }, 1000);

    // }
    setSelectSupplierPassingEvent(event);
    // setReferenceNo("");
    // setAccountId("");
    // setPaymentType("");
    // setPaymentTypeId(0);
    // setShowPopupForWarning(true);
    // if (showPopupForWarning) {
    // setOldSelectedSupplier(selectedSupplier)
    // const answer = window.confirm(
    //   "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    // );
  };

  // const customFilterOption = (option, rawInput) => {
  //   // Return true if the option should be visible, false to hide it
  //   const inputValue = rawInput.toLowerCase();
  //   const optionLabel = option.label.toLowerCase();
  //   return optionLabel.includes(inputValue);
  // };

  // handle change for all the input fields
  const handleChangeInput = (event, index, fieldName, row) => {
    console.log(event.target.value, "766 hwefjkjkfhk ", fieldName);
    // console.log(event.target.checked, fieldName,"Checked");
    if (fieldName === "Customer") {
      console.log(event.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
      }));
    } else if (fieldName === "CREDITAPPLIEDVALUE") {
      console.log(event.target.value.length, "gghhhh");

      const updatedData = [...formValues];
      if (
        (parseInt(event.target.value) <=
          // parseInt(updatedData[index].CREDITAPPLIED)  /** comment this line on 14/10/2023 for allowed credit based on OPEN BALANCE */
          parseInt(
            updatedData[index].OPENBALANCE
          ) /** add this line on 14/10/2023 for allowed credit based on OPEN BALANCE */ &&
          parseInt(event.target.value) <=
            parseInt(updatedData[index].CREDITAPPLIED)) ||
        event.target.value.length == 0
      ) {
        console.log(event.target.value.length, "gghhhh");
        const errordata = [...creditValidation];
        errordata[index] = false;
        setCreditValidation(errordata);

        const indexOfChange = updatedData.findIndex(
          (el) => el?.ReceivingID == row?.ReceivingID
        );
        console.log(indexOfChange, "indexOfChange");

        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: Number(event.target.value),
          ["PAYMENT"]:
            Number(updatedData[indexOfChange].OPENBALANCE) -
            Number(event.target.value),
          ["Checked"]: true,
        };
        setFormValues(updatedData);
      } else {
        const errordata = [...creditValidation];
        errordata[index] = true;
        setCreditValidation(errordata);

        const indexOfChange = updatedData.findIndex(
          (el) => el?.ReceivingID == row?.ReceivingID
        );

        let ValidationMessage = "Value must not exceed ";
        if (
          event.target.value > Number(updatedData[indexOfChange]?.CREDITAPPLIED)
        ) {
          ValidationMessage =
            "Value must not exceed " +
            Number(updatedData[indexOfChange]?.CREDITAPPLIED);
        } else if (
          event.target.value > Number(updatedData[indexOfChange]?.OPENBALANCE)
        ) {
          ValidationMessage =
            "Value must not exceed " +
            Number(updatedData[indexOfChange]?.OPENBALANCE);
        }

        setCreditValidationMessage(ValidationMessage);

        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: 0,
          ["PAYMENT"]: parseInt(updatedData[indexOfChange].OPENBALANCE), // - parseInt(event.target.value)
          ["Checked"]: true,
        };
        setFormValues(updatedData);
      }
    } else if (fieldName === "DepositTo") {
      console.log(event.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
      }));
    } else if (fieldName === "RefrenceNumber") {
      // console.log(event.target.value, fieldName);
      // setFormValues((prevValues) => ({
      //   ...prevValues,
      //   [fieldName]: parseInt(event.target.value)
      // }));
      const updatedData = [...formValues];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event.target.value,
      };
      setFormValues(updatedData);
    } else if (fieldName === "PaymentMethod") {
      console.log(event, "=====>data");
      // console.log(event.target.label, "=====>data");
      // const updatedData = [...formValues];
      // updatedData[index] = {
      //   ...updatedData[index],
      //   [fieldName]: parseInt(event.target.value),
      //   ["Paymentlabel"]: paymentMethodOption?.find(
      //     (el) => el.value == event.target.value
      //   )?.label,
      // };
      // setFormValues(updatedData);
      setPaymentType(event.target.value);
    } else if (fieldName === "InvoiceNumber") {
      console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
    } else if (fieldName === "Memo") {
      console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
    } else if (fieldName === "PaymentDate") {
      console.log(event.target.value, fieldName);
      setTodayDate(event.target.value);
    } else if (fieldName === "AmountReceived") {
      console.log(event.target.value, fieldName);
      setAmountReceived(event.target.value);
    } else if (fieldName === "PAYMENT") {
      const updatedData = [...formValues];

      const paymentValue = Number(event.target.value);
      const openBalanceValue = Number(updatedData[index].OPENBALANCE);

      // if (paymentValue > openBalanceValue -  updatedData[index].CREDITAPPLIEDVALUE) {
      //   // Prevent further action, as user should not be able to type
      //   return;
      // }

      /** ------------------------------------------------------------------------------------------  */
      /* Comment Below code on 14/10/2023 for Allowed Extra PAYMENT amount to OPEN BALANCE  */
      // if (paymentValue > openBalanceValue - updatedData[index].CREDITAPPLIEDVALUE) {
      //   const errordata = [...paymentValidation];
      //   errordata[index] = true;
      //   setPaymentValidation(errordata)

      //   const indexOfChange = updatedData.findIndex(
      //     (el) => el?.ReceivingID === row?.ReceivingID
      //   );
      //   updatedData[indexOfChange] = {
      //     ...updatedData[indexOfChange],
      //     // ["CREDITAPPLIEDVALUE"]: openBalanceValue - paymentValue,
      //     // ["Checked"]: true,
      //     // [fieldName]: 0,
      //   };

      // }
      // // else if (paymentValue === 0) {

      // //   const errordata = [...paymentValidation];
      // //   errordata[index] = false;
      // //   setPaymentValidation(errordata)

      // //   updatedData[index] = {
      // //     ...updatedData[index],
      // //     [fieldName]: paymentValue,
      // //     ["Checked"]: false,
      // //     // ['CREDITAPPLIEDVALUE']: openBalanceValue,
      // //   };
      // // }
      // else {

      //   const errordata = [...paymentValidation];
      //   errordata[index] = false;
      //   setPaymentValidation(errordata)

      //   // if( Number(updatedData[index].CREDITAPPLIED)<=0){
      //   //   updatedData[index] = {
      //   //     ...updatedData[index],
      //   //     [fieldName]: paymentValue,
      //   //     ["Checked"]: true,
      //   //     ['CREDITAPPLIEDVALUE']: 0,
      //   //   };
      //   // }else{
      //   updatedData[index] = {
      //     ...updatedData[index],
      //     [fieldName]: paymentValue,
      //     ["Checked"]: true,
      //     // ['CREDITAPPLIEDVALUE']: openBalanceValue - paymentValue,
      //   };
      //   // }
      //   setFormValues(updatedData);
      // }

      /* END Comment Below code on 14/10/2023 */
      /** ------------------------------------------------------------------------------------------  */

      /* Added Below code on 14/10/2023 for Allowed Extra PAYMENT amount to OPEN BALANCE  */
      const errordata = [...paymentValidation];
      errordata[index] = false;
      setPaymentValidation(errordata);
      // console.log(Number(updatedData[index].OPENBALANCE) , Number(updatedData[index]?.CREDITAPPLIEDVALUE),"4578")
      if (
        paymentValue <=
        Number(updatedData[index].OPENBALANCE) -
          Number(updatedData[index].CREDITAPPLIEDVALUE || 0)
      ) {
        if (
          oldSelectedSupplier == 0 || oldSelectedSupplier == row?.SupplierID || oldSelectedSupplier === undefined) {
          setOldSelectedSupplier(row?.SupplierID || 0);

          updatedData[index] = {
            ...updatedData[index],
            [fieldName]: paymentValue,
            ["Checked"]: true,
          };
          // toastSuccess("yes");
          setFormValues(updatedData);
        } else {
          toastError("You can't select more than one supplier in paybills");
        }
        
      } else {
        toastError("Payment can not be more than Open Balane");
      }
      /* END  Comment Below code on 14/10/2023 for Allowed Extra PAYMENT amount to OPEN BALANCE  */
    }
    // else if (fieldName === "PAYMENT") {
    //   const updatedData = [...formValues];

    //   if (Number(event.target.value) > Number(updatedData[index].OPENBALANCE)) {
    //     const errordata = [...creditValidation];
    //     errordata[index] = true;
    //     // setCreditValidation(errordata);

    //     const indexOfChange = updatedData.findIndex(
    //       (el) => el?.ReceivingID == row?.ReceivingID
    //     );

    //     updatedData[indexOfChange] = {
    //       ...updatedData[indexOfChange],
    //       ["CREDITAPPLIEDVALUE"]: Number(updatedData[index].OPENBALANCE) -
    //       Number(event.target.value),
    //       ["Checked"]: true,
    //     };
    //     setFormValues(updatedData);
    //     return
    //   }

    //   if (
    //     Number(event.target.value) == 0 &&
    //     (updatedData[index]?.CREDITAPPLIEDVALUE == 0
    //       ? true
    //       : updatedData[index]?.CREDITAPPLIEDVALUE == undefined)
    //   ) {
    //     updatedData[index] = {
    //       ...updatedData[index],
    //       [fieldName]: Number(event.target.value),
    //       ["Checked"]: false,
    //       ['CREDITAPPLIEDVALUE']: Number(updatedData[index].OPENBALANCE) -
    //         Number(event.target.value),
    //     };
    //   } else {
    //     updatedData[index] = {
    //       ...updatedData[index],
    //       [fieldName]: Number(event.target.value),
    //       ["Checked"]: true,
    //       ['CREDITAPPLIEDVALUE']: Number(updatedData[index].OPENBALANCE) -
    //         Number(event.target.value),
    //     };
    //   }
    //   setFormValues(updatedData);
    //   // setPaymentInputBox(event.target.value);
    //   // setFormValues((prevValues) => ({
    //   //   ...prevValues[index],
    //   //   [fieldName]: parseInt(event.target.value),
    //   // }));
    // }
    else if (fieldName === "Checked") {
      console.log(event, row, "fieldName");
      const updatedData = [...formValues];
      const indexOfChange = updatedData.findIndex(
        (el) => el?.ReceivingID == row?.ReceivingID
      );

      console.log(updatedData, "updatedData");

      if (event.target.checked) {
        if (
          oldSelectedSupplier == 0 || oldSelectedSupplier == row?.SupplierID || oldSelectedSupplier === undefined) {
          setOldSelectedSupplier(row?.SupplierID || 0);

          updatedData[indexOfChange] = {
            ...updatedData[indexOfChange],
            [fieldName]: event.target.checked,
            ["PAYMENT"]: Number(
              updatedData[indexOfChange].OPENBALANCE || 0
            ).toFixed(2),
          };
        } else {
          toastError("You can't select more than one supplier in paybills");
        }

        // if (row.CREDITAPPLIED > 0) {
        //   if(row.OPENBALANCE >= row.CREDITAPPLIED){
        //     updatedData[indexOfChange] = {
        //       ...updatedData[indexOfChange],
        //       [fieldName]: event.target.checked,
        //       // ["CREDITAPPLIEDVALUE"]: Number(
        //       //   updatedData[indexOfChange].CREDITAPPLIED
        //       //   ),

        //         // ["CREDITAPPLIED"]:0,
        //         ["PAYMENT"]:Number(updatedData[indexOfChange].OPENBALANCE),
        //       };
        //   }else{
        //     updatedData[indexOfChange] = {
        //       ...updatedData[indexOfChange],
        //       [fieldName]: event.target.checked,
        //       ["CREDITAPPLIEDVALUE"]: Number(
        //         updatedData[indexOfChange].OPENBALANCE
        //         ),
        //         ["PAYMENT"]: 0,
        //         ["CREDITAPPLIED"]: Number(updatedData[indexOfChange].CREDITAPPLIED) - Number(
        //           updatedData[indexOfChange].OPENBALANCE
        //           ) ,
        //       };
        //     }
        // } else {
        //   updatedData[indexOfChange] = {
        //     ...updatedData[indexOfChange],
        //     [fieldName]: event.target.checked,
        //     ["CREDITAPPLIEDVALUE"]: 0,
        //     ["PAYMENT"]: Number(updatedData[indexOfChange].OPENBALANCE),
        //   };
        // }
      } else {
        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: event.target.checked,
          ["CREDITAPPLIEDVALUE"]: "",
          ["PAYMENT"]: "",
          // ["CREDITAPPLIED"]:updatedData[indexOfChange].CREDITAPPLIEDVALUE
        };
        if (!updatedData.some(item => item.Checked === true)) {
          setOldSelectedSupplier(0);
      }
      
        // if(row.OPENBALANCE >= row.CREDITAPPLIED){

        //   updatedData[indexOfChange] = {
        //     ...updatedData[indexOfChange],
        //     [fieldName]: event.target.checked,
        //     ["CREDITAPPLIEDVALUE"]: 0,
        //     ["PAYMENT"]: 0,
        //     ["CREDITAPPLIED"]:updatedData[indexOfChange].CREDITAPPLIEDVALUE
        //   };
        // }else{
        //   updatedData[indexOfChange] = {
        //     ...updatedData[indexOfChange],
        //     [fieldName]: event.target.checked,
        //     ["CREDITAPPLIED"]: Number(updatedData[indexOfChange].CREDITAPPLIED) + Number(
        //       updatedData[indexOfChange].CREDITAPPLIEDVALUE
        //       ),
        //       ["PAYMENT"]: 0,
        //       ["CREDITAPPLIEDVALUE"]: 0,
        //   };

        // }
      }

      setFormValues(updatedData);
    } else {
      console.log("No Condition");
    }
  };

  const handleChangeRef = (event) => {
    console.log(event, "checkrefno");
    setReferenceNo(event.target.value);
  };

  const handleChangePrintStatus = (event) => {
    console.log(event, "checkrefno");
    setPrintLater(printLater ? false : true);
  };

  const handleChangePaymentMethod = (event) => {
    console.log(event, "checkrefno");
    setPaymentType(event.label);
    setPaymentTypeId(event.PaymentQuickbookId);
  };

  const handleUpdateSupplierCreditApplied = (
    supplierID,
    availableAmount,
    totalAmount,
    index
  ) => {
    console.log(supplierID, availableAmount, totalAmount, index, "837");
    const existingSupplierCreditIndex = supplierCreditAppliedValue.findIndex(
      (item) => item.supplierid === supplierID
    );

    if (existingSupplierCreditIndex !== -1) {
      const existingItem =
        supplierCreditAppliedValue[existingSupplierCreditIndex];
      existingItem.availableAmount = parseFloat(availableAmount);
      existingItem.TotalAmount = totalAmount;
      const updatedDataNew = [...supplierCreditAppliedValue];
      updatedDataNew[existingSupplierCreditIndex] = existingItem;
      setSupplierCreditAppliedValue(updatedDataNew);
    } else {
      // setSupplierCreditAppliedValue([
      //   ...supplierCreditAppliedValue,
      //   {
      //     supplierid: supplierID,
      //     availableAmount: availableAmount,
      //     TotalAmount: totalAmount,
      //   },
      // ]);

      const updatedData = [...formValues];

      updatedData[index] = {
        ...updatedData[index],
        ["AvailableAmount"]: availableAmount,
      };
      setFormValues(updatedData);

      setSupplierCreditAppliedValue([
        ...supplierCreditAppliedValue,
        {
          supplierid: supplierID,
          availableAmount: availableAmount,
          totalAmount: totalAmount,
        },
      ]);
    }
  };

  // console.log("valueisssssssss", value);

  const handleCellChange = (event, row, index) => {
    console.log(event.target.value, row, index, "handleCellChange");
    setValue(true);
    const creditValue = parseFloat(event.target.value);
    console.log("creditAppliedValue is..", creditValue);
    // const paymentValue = parseFloat(rowTotalAmount[index]?.payment) || 0;
    const paymentValueFilter = rowCreditTotalAmount.filter((e) => {
      return (
        e !== undefined &&
        e.supplierID === row.SupplierID &&
        e.receivingID == row.ReceivingID
      );
    });
    const paymentValue = parseFloat(paymentValueFilter?.payment) || 0;

    console.log("paymentValue is...", paymentValue);
    const newTotalAmount = creditValue + paymentValue;
    console.log("newTotalAmount is...", newTotalAmount);

    const updatedRowTotalAmount = [...rowCreditTotalAmount];
    updatedRowTotalAmount[index] = {
      payment: paymentValue,
      creditApplied: creditValue,
      totalAmount: newTotalAmount,
      supplierID: row.SupplierID || row?.SupplierId,
      receivingID: row.ReceivingID || row?.ReceivingId,
      isChecked: true,
    };
    setRowCreditTotalAmount(updatedRowTotalAmount);
    console.log("updatedRowTotalAmount 111==> ", updatedRowTotalAmount);
    setCreditAppliedInputBox(creditValue);

    console.log("Row Index", row);
    // Perform necessary calculations based on the event and row data...
    const newValue = event.target.value; // Get the new v
    let creditApplied = row.CREDITAPPLIED;

    // Update the creditAppliedValue state
    handleUpdateCreditApplied(
      newValue > 0 ? newValue : 0,
      row.SupplierID || row?.SupplierId,
      row.ReceivingID || row?.ReceivingId
    );
    console.log("creditAppliedValue 11 ===>", creditAppliedValue);

    let totalCount = 0;
    // let creditApplicationValueFilter = creditAppliedValue.filter(
    //   (e) => e.supplierid === row.SupplierID
    // );

    if (creditAppliedValue != undefined && creditAppliedValue != null) {
      let creditApplicationValueFilter = creditAppliedValue.filter((e) => {
        return e.supplierid === row.SupplierID;
      });
      totalCount = creditApplicationValueFilter.reduce(
        (a, v) => (a = parseFloat(a) + parseFloat(v.value)),
        0
      );
    }

    let availableAmount = parseFloat(creditApplied) - parseFloat(totalCount);

    let totalAmount = row.CREDITAPPLIED;
    handleUpdateSupplierCreditApplied(
      row?.SupplierID,
      availableAmount,
      totalAmount,
      index
    );
  };
  // useEffect(() => {
  //   setTotalAmount(parseInt(paymentInputBox) + parseInt(creditAppliedInputBox));
  // }, [paymentInputBox, creditAppliedInputBox]);

  const handleSubmit = (afterSaveActionType) => {
    // console.log("chartOfAccountDropdown", chartOfAccountDropdown);
    // chartOfAccountDropdown.map((el) => {
    let pData, cab;
    if (balanceAmount !== 0) {
      // return alert("Please fill");
      // console.log("111111111111111111111");
      console.log("FormValues ==> ", formValues);
      console.log("amountReceived ==> ", amountReceived);
      console.log("Attactment ==> ", FileUrl);
      console.log("Payment Date ==> ", todayDate);
      console.log("123data===>", pData);
      if (paramObject.id > 0) {
        pData = formValues.map((el) => {
          const mappedData = {
            id: el?.ID,
            ReceivingId: el?.ReceivingId,
            SupplierIds: el?.SupplierID,
            CreditApplied: el?.CREDITAPPLIEDVALUE,
            PaymentAmount: el?.PAYMENT,
            PaymentmethodId: el?.PaymentMethod,
            Paymentmathod: el?.Paymentlabel,
            Supplierquickbookid: el?.supplierquickbookid,
            billtype: el?.BILLTYPE,
            paymentmethodname: el?.Paymentlabel,
            RefNo: el?.RefrenceNumber,
            TotalAmount:
              parseFloat(el?.CREDITAPPLIEDVALUE ? el?.CREDITAPPLIEDVALUE : 0) +
              parseFloat(el?.PAYMENT ? el?.PAYMENT : 0),
            //QuickBookId: el?.QuickbookId,
            QuickBookId: el?.ReceivingQuickbookId,
          };
          return mappedData;
        });
      } else {
        cab = formValues.map((el) => {
          if (el?.Checked) {
            const mapped = {
              ReceivingId: el?.ReceivingID,
              SupplierIds: el?.SupplierID,
              CreditApplied: el?.CREDITAPPLIEDVALUE,
              PaymentAmount: el?.PAYMENT,
              billtype: el?.BILLTYPE,
              PaymentmethodId: el?.PaymentMethod,
              Paymentmathod: el?.Paymentlabel,
              Supplierquickbookid: el?.SupplierQuickBookId,

              paymentmethodname: el?.Paymentlabel,
              RefNo: el?.RefrenceNumber,
              TotalAmount:
                parseFloat(
                  el?.CREDITAPPLIEDVALUE ? el?.CREDITAPPLIEDVALUE : 0
                ) + parseFloat(el?.PAYMENT ? el?.PAYMENT : 0),
              id: 0,
              QuickBookId: el?.QuickbookId,
            };
            return mapped;
          }
        });
      }

      if(paymenttypeid == 0){
        toastError("Please select Payment Method");
        return
      }
      console.log("pData", pData);
      console.log("=========>>>>>>", cab);
      let PayBillsItemData = cab?.filter(function (payBillsItem) {
        return payBillsItem?.ItemId != "" && payBillsItem != null;
      });
      let PayBillsItempData = pData?.filter(function (payBillsItem) {
        return payBillsItem?.ItemId != "" && payBillsItem != null;
      });
      const payBillsItemobj = {};
      const billitemsxmlObj = {};
      billitemsxmlObj.billitemsxml =
        paramObject.id > 0 ? PayBillsItempData : PayBillsItemData;
      payBillsItemobj.billitemsxmldata = billitemsxmlObj;
      // payBillsItemobj.billitemsxmldata = PayBillsItemData;
      let paybillsjsonstring = JSON.stringify(payBillsItemobj);
      console.log("billitemsxmldata: ", paybillsjsonstring);
      // return true;
      const submitData = {
        xmlbillitems: paybillsjsonstring,
        accountid: accountId,
        accountquickbookid: Accountquickbookid,
        payeequickbookid: payeequickbookid,
        paymentdate: moment(todayDate).format("YYYY/MM/DD"),
        amountreceived: total,
        locationid: locationId,
        loginuserid: Id,
        notlisteddata: notlisteddata,
        id: paramObject.id == undefined ? 0 : paramObject.id,
        receivingpaymentid: receivingpaymentid,
        paymenttype: paymenttype == "Check" ? "Check" : "CreditCard",
        quickbooktotalamount: Number(total) - Number(totalCreditValue),
        RefeNo: referenceNo,
        paymenttypeQBid: paymenttypeid,
        printstatus: printLater ? 1 : 0,
      };
      console.log("submit data====>>>", submitData);
    
      setLoading(true);
      axios
        .post(
          `${config.receivingBaseUrl}/receivings/receivingpaybillupsert`,
          submitData,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res data ==========>>>>", res);
          if (res.data.ResponseCode === "SUCCESS") {
            toastSuccess(SUCCESS_MESSAGE);

            // if (paramObject.id == undefined) {
            //   window.location.reload();
            // } else {
            //   navigate(-1);
            // }
            console.log(afterSaveActionType,"afterSaveActionType");
            
            if (afterSaveActionType == "saveandnew") {
              window.location.reload();
            } else if (afterSaveActionType == "saveandclose") {
              navigate("/transaction-log");
            }
            setLoading(false);
            console.log("res.data.ResponseID", res.data.ResponseID);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            setLoading(false);
            toastError(res.data.ResponseMessage);
          } else {
            setLoading(false);
            toastError(ERROR_MESSAGE);
          }
          // setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          // setLoading(false);
        });
    } else {
      toastWarn("Please fill all the Details");
    }
  };

    const callSupplierGetApi = (ID) => {
         axios
            .get(
              `${config.suppliersBaseUrl}/suppliers/findbyid?id=${ID}&locationid=${locationId}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((response) => {
              if (
                response.data.ResponseData.Items[0] != undefined &&
                response.data.ResponseData.Items[0] != null
              ) {
                let supplierData = response.data.ResponseData.Items[0];              
                setSupplierOpenBalance(supplierData.OpenBalance);
              }
            })
            .catch((error) => {
              console.log(error);
            });
    };

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    selectedSupplier,
    refrenceno,
    beginningDate,
    finalDate
  ) => {
    const supplierId = 0;
    // selectedSupplier && selectedSupplier.value ? selectedSupplier.value : 0;

    console.log("selectedSupplier:", selectedSupplier);

    beginningDate =
      beginningDate == undefined
        ? ""
        : beginningDate == null
        ? ""
        : beginningDate;
    finalDate =
      finalDate == undefined ? "" : finalDate == null ? "" : finalDate;

    // if (showPopupForWarning) {
    //   const answer = window.confirm(
    //     "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    //   );
    //   if (!answer) {
    //     console.log(answer, "answer")
    //     setSelectedSupplier(2);
    //     setShowPopupForWarning(false)
    //     return;
    //   }
    // }

    setLoading(true);
    // console.log(
    //   "selectedSupplier.value:",
    //   selectedSupplier && selectedSupplier.value
    // );

    // console.log("supplierId:", supplierId);
    paramObject.id === undefined &&
      axios
        .get(
          `${config.receivingBaseUrl}/receivings/paybill_list?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}&supplierid=${selectedSupplier}&refrenceno=${refrenceno}&locationid=${locationId}&startdate=${beginningDate}&enddate=${finalDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            setRowPaymentTotalAmount([]);
            setRowCreditTotalAmount([]);
            console.log("res.data.ResponseData", res.data.ResponseData);
            setData(res.data.ResponseData);
            let newArray = res.data.ResponseData.map((obj) => {
              return {
                ...obj,
                ...(obj?.REFNO === refrenceno
                  ? {
                      Checked: true,
                      PAYMENT: parseInt(obj?.OPENBALANCE).toFixed(2),
                    }
                  : { Checked: false }),
                // Checked: false,
                PaymentMethod: 1,
                Paymentlabel: "Cash",
              };
            });

            function checkSupplierID(data) {
              if (!Array.isArray(data) || data.length === 0) return null;

              const firstSupplierID = data[0].SupplierID;
              const firstSupplierQuickBookId = data[0].SupplierQuickBookId;

              const allSame = data.every(
                (item) => item.SupplierID === firstSupplierID
              );

              return allSame
                ? {
                    SupplierID: firstSupplierID,
                    SupplierQuickBookId: firstSupplierQuickBookId,
                  }
                : null;
            }

            const result = checkSupplierID(newArray);
            console.log(result, "result of checkSupplierID");
            if (result) {
              setSelectSupplierPassingEvent(result?.SupplierID);
              setpayeequickbookid(result?.SupplierQuickBookId);
              setOldSelectedSupplier(result?.SupplierID);
            }

            localStorage.removeItem("paybillSupplierid");
            setFormValues(newArray);
            setTotalRows(res.data.ResponseData[0]?.TotalRecord);
            setLoading(false); // Set loading state to false after data is fetched
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseData[0]?.ID == -1
          ) {
            setLoading(false);
            toastError(res.data.ResponseMessage);
          }
        })

        .catch((err) => {
          setLoading(false); // Set loading state to false in case of an error
        });
  };

  // const handleSupplierSelection = (selectedOption) => {
  //   // console.log("selectedSupplier is", selectedSupplier);
  //   console.log("selectedOption:>>", selectedOption);
  //   setSelectedSupplier(selectedOption.value);
  //   console.log("setSelectedSupplier===>", selectedOption.value); // Update the selected supplier
  //   // handleListData(selectedOption.value); // Call handleListData with the selected supplier
  // };

  // const handleSupplierSelection = (selectedOption) => {
  //     console.log("selectedOptionselectedOption", selectedOption.value);
  //     setSelectedSupplier(selectedOption.value); // Update the selected supplier
  // };
  console.log("selectedSupplier>>>:::::", selectedSupplier);

  const SingleRowTotal = () => {
    console.log("creditAppliedInputBox>>", creditAppliedInputBox);
    console.log("paymentInputBox>>", paymentInputBox);
    const rowTotal = creditAppliedInputBox + paymentInputBox;
    console.log("rowTotal", rowTotal);
    // return rowTotal
  };
  const filteredData = formValues.filter(
    (item) => !moment(item.DUEDATE).isSameOrAfter(moment())
  );

  console.log(filteredData, "filteredData");

  useEffect(() => {
    let storedData = JSON.parse(
      localStorage.getItem("paybillSupplierid")
        ? localStorage.getItem("paybillSupplierid")
        : 0
    );

    console.log(storedData, "storedDatajhgikdfjh");
    setOldSelectedSupplier(storedData || selectedSupplier);
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      storedData || selectedSupplier,
      refrenceno,
      beginningDate,
      finalDate
    );

    SupplierAPI();
    PaymentMethodAPI();
    CustomerAPI();
    AccountAPI();
  }, [
    // perPageSize,
    searchtext,
    sortingId,
    sortingDirection,
    selectedSupplier,
    refrenceno,
  ]);

  useEffect(() => {
    if (paramObject?.id > 0) {
      axios
        .get(
          `${config.receivingBaseUrl}/receivings/paybilldetails?id=${paramObject?.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setRowPaymentTotalAmount([]);
          setRowCreditTotalAmount([]);

          console.log("get receiving paymentdata by id", res.data.ResponseData);
          setBeginningDate(res.data.ResponseData[0].DueDate);
          setFinalDate(res.data.ResponseData[0].DueDate);

          setData(res.data.ResponseData);
          const filteredarray = res.data.ResponseData.filter((obj) => {
            return obj.ID == paramObject.id;
          });
          setData(res.data.ResponseData);
          const filteredarraynotinlist = res.data.ResponseData.filter((obj) => {
            return obj.ID != paramObject.id;
          });
          setNotListedData(filteredarraynotinlist);
          console.log(filteredarray, "filteredarray===>>");
          let newArray = filteredarray.map((obj) => {
            return {
              ...obj,
              Checked: true,
              PaymentMethod: obj.PaymentTypeId,
              CREDITAPPLIED: obj.CustomerBalance,
              OPENBALANCE: obj.OpeningBalance,
              RefrenceNumber: obj.RefNo,
              CREDITAPPLIEDVALUE: parseFloat(obj.CreditApplied).toFixed(2),
              PAYMENT: parseFloat(obj.PaymentAmount).toFixed(2),
              SupplierID: obj.SupplierId,
            };
          });
          console.log(newArray, "newArray===>>");
          setFormValues(newArray);
          setOldSelectedSupplier(newArray[0].SupplierId);
          setpayeequickbookid(newArray[0].supplierquickbookid);
          setPaymentType(
            newArray[0].PaymentTypeId == 2
              ? "Check"
              : newArray[0].PaymentTypeId == 5
              ? "CreditCard"
              : ""
          );
          setAccountquickbookid(newArray[0].accountquickbookid);
          setReceivingPaymentId(newArray[0].ReceivingpaymentQuickbookId);
          setLoading(false);
          let resData = res.data.ResponseData[0];
          console.log(resData, "responsedata===>");
          setPayBillData(res.data.ResponseData);
          setBalanceAmount(resData?.Balance);
          setAccountId(resData?.AccountTypeID);
          // console.log(balanceAmount, "balanceAmount")
          // console.log(resData?.AccountTypeID, "accountId");
          // // setTodayDate(moment(resData?.PaymentDate).format("MM-DD-YYYY"))
          setTodayDate(moment(resData?.PaymentDate).format("MM-DD-YYYY"));
          // console.log(moment(res?.data?.ResponseData[0].PaymentDate).format("MM-DD-YYYY"),"1887")
          // console.log(res?.data?.ResponseData[0].PaymentDate,"1887")
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    if ((paymenttype == "Check" || paymenttype == "Cash" ) && (accountId > 0 || accountId != "")){
      latestCheckNumberAPI();
    }
  }, [paymenttype, accountId]);

  const formData = formValues.filter((el) => el.SupplierID == selectedSupplier);
  console.log(formData, "formData1192");

  const handleClearModalPopup = () => {
    console.log("CALL POPUP EVENT");
  };

  const totals = formValues?.reduce(
    (accumulator, currentObject) => {
      accumulator.openingBalanceTotal += Number(currentObject.OPENBALANCE);
      accumulator.creditAppliedTotal += Number(
        currentObject.CREDITAPPLIEDVALUE
      );
      accumulator.paymentAmountTotal += Number(currentObject.PAYMENT);
      // accumulator.FinalTotal += Number(currentObject.Total);
      return accumulator;
    },
    {
      openingBalanceTotal: 0,
      creditAppliedTotal: 0,
      paymentAmountTotal: 0,
      FinalTotal: 0,
    }
  );

  console.log("Total 1828:", totals);

  const isMobile = window.innerWidth < 500;

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title" >Receiving</h3> */}
              <ul className="breadcrumb Tab_Screen_Size_Breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">Pay Bills</li>
              </ul>
            </div>
          </div>

          {/* Receive Payment Card */}
          <div className="card">
            <div className="card-body">
              {!QBpermission && AllowQBSync && (
                <QuickbookSyncMessageComponent type="Pay Bills" />
              )}
              <button
                className="btn btn-sm pt-0 ps-0"
                type="button"
                data-bs-target="#RecentTransactionsModal"
                data-bs-toggle="modal"
                // onClick={() => setShowRecentList(true)}
              >
                {/* <HistoryIcon />  */}

                <i class="fa fa-history fs-4"></i>
              </button>
              <span className="p-lg">{"Pay Bills"}</span>
              {/* First Row */}
              <div
                className="col-md-10"
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <div
                  className="row"
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <div className="col-sm-12 col-md-4 col-lg-3">
                    <div className="col-form-label">Supplier</div>
                    <Select
                      options={supplierTypeDropdownOption}
                      value={supplierTypeDropdownOption.find(
                        (option) => option?.value == oldSelectedSupplier
                      )}
                      onChange={(event) => {
                        console.log(event, "data====>");
                        selectSupplierHandle(event?.value);
                        setpayeequickbookid(event?.quickbookid);
                        callSupplierGetApi(event?.value);
                        // setSupplierOpenBalance(event.supplierbalance);
                        setAccountId(accountId);
                      }}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="Supplier"
                      name="Supplier"
                      isOptionDisabled={(option) => option.value == 0}
                      className="custom-search-select"
                      getOptionLabel={(option) =>
                        option.value === 0 ? "Select a Supplier" : option.label
                      }
                    />
                  </div>
                  <div className="col-sm-12 col-md-2 col-lg-2">
                    <div className="col-form-label">Search Bill No:</div>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Bill No."
                      name="ReferenceNumber"
                      id="ReferenceNumber"
                      onChange={(event) => setRefrenceNo(event.target.value)}
                    />
                  </div>
                  <div className="col-sm-12 col-md-3 col-lg-2">
                    <div className="col-form-label">Due Date:</div>
                    <Select
                      onChange={(event) => {
                        handleDateFilter(event);
                      }}
                      placeholder="Select Due Date"
                      options={dateOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={dateOptions.find((el) => el?.value == customeDate)}
                      isOptionDisabled={(option) => option.value == 0}
                      className="custom-search-select"
                    />
                  </div>

                  {isMobile ? (
                    <div className="d-flex gap-1">
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="col-form-label">From:</div>
                        <CommonDatePicker
                          FinalDate={beginningDate}
                          handleDateChange={handleDate}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="col-form-label">To:</div>
                        <CommonDatePicker
                          FinalDate={finalDate}
                          handleDateChange={handleEndDate}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="col-form-label">From:</div>
                        <CommonDatePicker
                          FinalDate={beginningDate}
                          handleDateChange={handleDate}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="col-form-label">To:</div>
                        <CommonDatePicker
                          FinalDate={finalDate}
                          handleDateChange={handleEndDate}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Receive Payment Table Card */}
          <div className="card">
            <div className="card-body" style={{ padding: "8px" }}>
              <div className="card-body" style={{ padding: "8px" }}>
                {/* First Row */}
                <div className="row d-flex flex-row">
                  {/* Account Selection */}
                  <div className="p-2 col-12 col-sm-12 col-md-4 col-lg-4">
                    <div className="col-form-label"> Account: <span className="text-danger">*</span></div>
                    <Select
                      onChange={(event) => {
                        console.log(event, "eventdata===>");
                        setBalanceAmount(
                          event?.amount == undefined ? 0 : event?.amount
                        );
                        setAccountId(event?.value);
                        setAccountquickbookid(event?.quickbookid);
                        console.log(event?.value, "accountCheck");
                      }}
                      options={accountTypeDropdownOption}
                      value={accountTypeDropdownOption?.find(
                        (option) => option?.value === accountId
                      )}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="AccountId"
                      name="AccountId"
                      className="custom-search-select"
                      formatOptionLabel={({ label, parentName, AccountType }) => (
                      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <span>{label}</span>
                        <span style={{ fontStyle: "italic", color: "#666", marginLeft: "1rem" }}>
                          {parentName ? `Sub-account of ${parentName}` : AccountType}
                        </span>
                      </div>
                    )}
                    />
                  </div>

                  {/* Balance Display */}
                  <div className="p-2 col-12 col-sm-12 col-md-3 col-lg-2">
                    <div className="d-flex flex-column">
                      <div className="p-1">
                        <label className="col-form-label">Account Balance: </label>
                      </div>
                      <div className="p-1">
                        <span>
                          <strong>
                            {" "}
                            {CurrencySymbols(
                              Number(balanceAmount),
                              CurrencySymbol,
                              FractionDigits
                            )}
                          </strong>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="p-2 col-md-2">
                    <div className=" col-form-label">Payment Method:<span className="text-danger">*</span></div>
                    <Select
                      options={paymentMethodOption}
                      placeholder="Select Method"
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="PaymentMethod"
                      name="PaymentMethod"
                      // isClearable={true}
                      onChange={(event) => handleChangePaymentMethod(event)}
                      // value={paymenttype}
                      value={paymentMethodOption.find(
                        (el) => el?.PaymentQuickbookId == paymenttypeid
                      )}
                      className="custom-search-select"
                    />
                    {/* {showPaymentMethodError && (
                    <p className="text-danger mb-0">
                      * Payment Method is required
                    </p>
                  )} */}
                  </div>
                  <div className="p-2 col-md-2">
                    <div className=" col-form-label">Reference Number:</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Ref No."
                      name="ReferenceNumber"
                      id="ReferenceNumber"
                      onChange={(event) => handleChangeRef(event)}
                      value={printLater ? "To print": referenceNo}
                    />
                  </div>
                  {paymenttype == "Check" && (
                    <div className="p-2 col-md-1">
                      <div className=" col-form-label">Print Later:</div>
                      <input
                        type="checkbox"
                        className="mt-2 ms-2"
                        name="printstatus"
                        id="printstatus"
                        onChange={(event) => handleChangePrintStatus(event)}
                        checked={printLater}
                      />
                    </div>
                  )}
                  {/* Payment Date */}
                  <div className="p-2 col-12 col-sm-12 col-md-3 col-lg-2">
                    <div className="col-form-label">Payment Date: </div>
                    <CommonDatePicker
                      FinalDate={todayDate}
                      handleDateChange={handlepaymentdatechange}
                    />
                  </div>

                  {/* Total Payment Amount */}
                  <div
                    className="p-2 col-12 col-sm-12 col-md-2 col-lg-2 ms-auto text-md-end"
                    // style={{ width: "42%" }}
                  >
                    <p className="p-medium">TOTAL PAYMENT AMOUNT</p>
                    <p className="p">
                      {CurrencySymbols(
                        Number(total),
                        CurrencySymbol,
                        FractionDigits
                      )}
                    </p>

                    {paramObject.id > 0 ? (
                      ""
                    ) : (
                      <div
                        className="d-flex justify-content-end"
                        style={{ fontSize: "18px" }}
                      >
                        <div>{formValues.length + " "}open bill</div>
                        {formValues.length > 0 && filteredData.length > 0 && (
                          <div>
                            , {filteredData.length} overdue
                            <i
                              className="fa fa-circle"
                              style={{ color: "red" }}
                            ></i>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {true && (
                <>
                  <div
                    style={{ width: "100%", whiteSpace: "normal !important" }}
                  >
                    <DataTable
                      // title="Outstanding Transactions"
                      columns={outstandingColumns}
                      data={formData.length == 0 ? formValues : formData}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={(e) => {
                        handlePerRowsChange(1, e);
                      }}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      striped
                      paginationRowsPerPageOptions={[100, 500]}
                      paginationPerPage={rowsPerPage}
                      persistTableHead
                      // selectableRows
                      // onSelectedRowsChange={(e) => handleCheckboxChange(e)}
                      sortServer
                      onSort={handleSort}
                    />
                  </div>
                </>
              )}
              <div
                className="Paybill_Details"
                // style={{
                //   marginRight: "2rem",
                //   display: "flex",
                //   justifyContent: "flex-end",
                //   gap: "4rem",
                //   alignItems: "center",
                //   height: "5rem",
                // }}
              >
                {paramObject.id > 0 ? (
                  ""
                ) : (
                  <p
                  // className="bold"
                  >
                    {totalChecked} bills selected
                  </p>
                )}
                {/* </div> */}
                {/* <div
                // className="col-md-3"
                >
                  <p>
                    Total payment (USD):{" "}
                    {CurrencySymbols(
                      Number(paramObject.id > 0 ? paymentTotal : total),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </p>
                </div> */}
                <div>
                  <p>
                    {" "}
                    Total OpenBalance:{" "}
                    {CurrencySymbols(
                      Number(
                        paramObject?.id > 0
                          ? totals?.openingBalanceTotal
                          : totalOpenBalance
                      ),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </p>
                </div>
                <div>
                  <p>
                    {" "}
                    Total Credit:{" "}
                    {CurrencySymbols(
                      Number(
                        paramObject?.id > 0
                          ? totals?.creditAppliedTotal
                          : totalCreditValue
                      ),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </p>
                </div>
                <div>
                  <p>
                    {" "}
                    Total Payment:{" "}
                    {CurrencySymbols(
                      Number(
                        paramObject?.id > 0
                          ? totals?.paymentAmountTotal
                          : totalPayment
                      ),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </p>
                </div>
                <div>
                  <p>
                    {" "}
                    Total Amount:{" "}
                    {CurrencySymbols(
                      Number(
                        paramObject?.id > 0
                          ? totals?.creditAppliedTotal +
                              totals?.paymentAmountTotal
                          : totalCreditValue + totalPayment
                      ),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </p>
                </div>
              </div>
              <div className="p-2 font-bold flex-end text-right">
                  <div>
                    <p>
                      {" "}
                      Supplier's Current open balance :{" "}
                      <span>
                        {CurrencySymbols(
                          Number(supplierOpenBalance),
                          CurrencySymbol,
                          FractionDigits
                        )}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      Total payment :{" "}
                      <span>
                        {CurrencySymbols(
                          Number(
                            paramObject?.id > 0
                              ? totals?.paymentAmountTotal
                              : totalPayment
                          ),
                          CurrencySymbol,
                          FractionDigits
                        )}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      Supplier's new open balance :{" "}
                      {paramObject.id > 0 ? (
                        <span>
                          {CurrencySymbols(
                            Number(
                              supplierOpenBalance - totals?.paymentAmountTotal
                            ),
                            CurrencySymbol,
                            FractionDigits
                          )}
                          {/* {CurrencySymbols(
                            Number(
                              balanceAmount - paymentTotal
                                ? balanceAmount - paymentTotal
                                : 0
                            ),
                            CurrencySymbol,
                            FractionDigits
                          )} */}
                        </span>
                      ) : (
                        <span>
                          {CurrencySymbols(
                            Number(
                              supplierOpenBalance - total
                                ? (supplierOpenBalance - total).toFixed(2)
                                : 0
                            ),
                            CurrencySymbol,
                            FractionDigits
                          )}
                        </span>
                      )}
                      {/* <span>
                        {balanceAmount - total
                          ? (balanceAmount - total).toFixed(2)
                          : 0}
                      </span> */}
                    </p>
                  </div>
              </div>

              {/* Credits Table */}
              {/* {true && (
                                <>
                                    <div className="table-responsive">
                                        <DataTable
                                            title="Credits"
                                            columns={creditsColumns}
                                            // data={data}
                                            // progressPending={loading}
                                            pagination
                                            paginationServer
                                            // paginationTotalRows={totalRows}
                                            // paginationDefaultPage={currentPage}
                                            // onChangeRowsPerPage={(e) => {
                                            //   handlePerRowsChange(1, e);
                                            // }}
                                            // onChangePage={handlePageChange}
                                            highlightOnHover
                                            striped
                                            responsive
                                            paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                                            persistTableHead
                                            selectableRows
                                            sortServer
                                        // onSort={handleSort}
                                        // contextActions={contextActions}
                                        // onSelectedRowsChange={handleRowSelected}
                                        // clearSelectedRows={toggleCleared}
                                        />
                                    </div>
                                </>
                            )} */}

              {/* Handle Clear payment */}
              {/* {true && (
                                <>
                                    <div className="pull-right">
                                        <div>
                                            <h6 className="fw-bold">
                                                Amount to Apply:&nbsp;&nbsp;&nbsp;&nbsp; $
                                                {amountReceived}
                                            </h6>
                                            <h6 className="fw-bold">
                                                Amount to Credit:&nbsp;&nbsp;&nbsp;&nbsp; $
                                                {amountReceived}
                                            </h6>
                                            <button className="btn btn-primary">Clear Payment</button>
                                        </div>
                                    </div>
                                </>
                            )} */}

              <div className="d-flex flex-column-reverse mb-3">
                {/* <div className="p-2 col-md-3">
                                    Memo:
                                    <textarea
                                        className="form-control"
                                        name="Memo"
                                        placeholder="Note"
                                        style={{ width: "410px", height: "150px" }}
                                        onChange={(event) => handleChangeInput(event, "Memo")}
                                    ></textarea>
                                </div>
                                <div className="p-2 col-md-3">
                                    Attachment:
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="Attachment"
                                        name="Attachment"
                                        accept=".pdf,.jpg,.jpeg,.heic,.png"
                                        onChange={handleFileChange}
                                    />
                                </div> */}
              </div>
              <div className="pull-right">
                <button
                  className="btn btn-sm btn-secondary me-2"
                  // onClick={handleCancel}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                {(formValues.filter((el) => el.Checked == true).length > 0 &&
                  oldSelectedSupplier > 0) ||
                paramObject?.id > 0 ? (
                  <>
                    {/* <button className="btn btn-primary" onClick={handleSubmit}> */}
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        setClickedButtonType("saveandclose");
                        handleConfirmationSubmit("saveandclose");
                      }}
                    >
                      Save & Close
                    </button>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => {
                        setClickedButtonType("saveandnew");
                        handleConfirmationSubmit("saveandnew");
                      }}
                    >
                      Save & New
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="FundModal"
        tabIndex="-1"
        // aria-labelledby="delete"
        // data-bs-backdrop="static"
        // data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          // role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">Confirmation</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <p>
                    You don't have sufficient balance in your chart of accounts.
                    Do you still want to make this transaction?
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => handleSubmit(clickedButtonType)}
              >
                Yes
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                No
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bill Redirection POPUP */}
      <div
        className={`modal ${showBillRedirectModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">Warning</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCancelRedirect}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <p>Do you want to leave without saving?</p>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleConfirmRedirect()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancelRedirect}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* popup for filter  */}
      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model">Warning</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleDateFilterCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <p>Do you want to leave without saving?</p>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#ClearDataPayBill"
        ref={buttonRef}
        style={{ opacity: "0" }}
      ></button>
      <ClearDataPayBill handleYes={handleYes} />
      <RecentTransactionsModal transactionType="Bill Payment" id={7} />
    </>
  );
};

export default PayBills;
